module.exports = __webpack_public_path__ + "static/media/heart.c86cd75b.png";